<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="exchangeordertrade" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '选择单据',
				modal_width:800,
				modal_height:500,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						type: 'radio',
						title: '#',
						width:50
					},
					{
						field: 'salercpt_no',
						title: '单据编码',
					},
					{
						field: 'tp_payment',
						title: '金额'
					},
					{
						field: 'tp_memo',
						title: '线上备注'
					},
					{
						field: 'remark',
						title: '系统备注'
					},
					// {
					// 	field: 'bill_type',
					// 	title: '类型',
					// 	slots: {
					// 		default: ({row}) => {
					// 			if(row.bill_type == 2){
					// 				return '售后'
					// 			}
					// 			return ''
					// 		}
					// 	}
					// },
					// {
					// 	field: 'c',
					// 	title: 'c',
					// 	formatter: 'datetime'
					// },
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
				gridOptions.toolbarConfig.buttons = []
				gridOptions.radioConfig = {
					trigger:'row'
				}
				
			},
			//page,updateForm,other
			list() {
				return new Promise((resolve) => {
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)
					resolve({
						list: this.data
					})
				})
			},
			submit() {
				let data = this.$refs.exchangeordertrade.getRadioRecord()
				if(!data){
					this.$message.error('请选择单据')
					return
				}
				this.$emit('submit',data)
				this.modal_cancel()
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>